import React, { useState, useRef } from 'react';

export default function InputTextarea(props) {
  const [ textLength, setTextLength ] = useState(0);
  const {
    className,
    cols,
    rows,
    minCharacters,
    maxCharacters,
    inputClassName,
    placeholder,
    name,
    value,
    setValue,
    setDirty,
    labelText,
    disableAutoComplete,
  } = props;
  const inputRef = useRef();

  return (
  <div className={`input-textarea df fxdrc h100% ${ className || ''}`}>
    {labelText && 
    <label
      className="input-textarea__label fw600 c-black mb8"
      htmlFor={name}
    >
      {labelText}
    </label>
    }
    {minCharacters &&
    <div className="fw600 mb8">
      { minCharacters } Characters Minimum      
    </div>
    }
    {maxCharacters &&
    <div className="fw600 mb8">
      { maxCharacters } Characters Maximum      
    </div>
    }
    <textarea
      className={`input-textarea__input mih80 h80  p20 h100% w100% ${ inputClassName || '' }`}
      ref={inputRef}
      rows={rows || 30}
      cols={cols || 80}
      id={name}
      name={name}
      value={value}
      autoComplete={disableAutoComplete ? 'off' : 'on'}
      onChange={e => setValue({ [`${name}`] : inputRef.current.value })}
      onBlur={e => setDirty({ [`${name}Dirty`] : true })}
      placeholder={placeholder}
    />
  </div>
  )
}